export * from './bundle-delete-template';
